import React from "react";
import NoDataFound from "./NoData";
import VoucherCard from "./VoucherCard";
import CustomSlider from "../../components/Slider/CustomSlider";
import { FormatFlooringVouchers } from "../../common/Constants";

function ActiveVouchersContent(props) {
  const { active_vouchers, handleCreateNewClick, HandleEdit, HandleDelete, pagePermission } =
    props;
  const handleNoDataClick = () => {
    handleCreateNewClick();
    console.log("Click Create");
  };

  const HandleActiveEdit = (id, label) => {
    HandleEdit(id, label, "active")
  }

  const updatedActiveVoucher = FormatFlooringVouchers(active_vouchers?.map((it) => {
    return {
      ...it,
      active: it?.active == 1 ? false : true,
      temp_date: it?.created_date
    };
  }));

  return (
    <div className="pending-vouchers-section">
      {active_vouchers.length === 0 ? (
        <NoDataFound
          onNewClick={handleNoDataClick}
          btnName="Create New Voucher"
          heading="Oh oh! No Voucher Found"
          noDataInfo="Seems like you don’t have any voucher available click
        below to create new one"
        />
      ) : (
        updatedActiveVoucher && updatedActiveVoucher?.length > 0 &&
        updatedActiveVoucher?.map((it) => (

          <div>
            <div className="hr-line-menu">
              <div className="hr-line-block">
                <h2>
                  <span>Created on:</span>{" "}
                  {it?.date}
                </h2>
              </div>
            </div>
            <div className="voucher-preview-section activeVouchers">
              <CustomSlider>
                {it?.vouchers?.length > 0 &&
                  it?.vouchers.map((voucher, index) => (
                    <VoucherCard
                      key={index}
                      voucher={voucher}
                      showBentoMenu={true}
                      type="active"
                      HandleEdit={HandleActiveEdit}
                      HandleDelete={HandleDelete}
                      pagePermission={pagePermission}
                    />
                  ))}
              </CustomSlider>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default ActiveVouchersContent;
